import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {
  fetchArchiveProjects,
  fetchProjectsList,
  setProjectSearchParam,
  setArchiveProjectSearchParam,
} from '../../actions/projects';
import { PER_PAGE_LIMIT } from '../../constants';

const ProjectSearch = ({ statusType }) => {
  const dispatch = useDispatch();
  const activeProjects = useSelector((state) => state.projectsList);
  const archiveProjects = useSelector((state) => state.archiveProjects);

  const handleSearchActive = () => {
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      page: activeProjects.page,
      limit: 9,
      summaryList: false,
      status: 'active',
      filter: JSON.stringify({
        projectTitle: activeProjects.searchParam,
      }),
    };
    dispatch(fetchProjectsList(params));
  };

  const handleSearchArchive = () => {
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      page: archiveProjects.page,
      limit: PER_PAGE_LIMIT,
      summaryList: false,
      filter: JSON.stringify({
        projectStatus: 'close',
        projectTitle: archiveProjects.searchParam,
      }),
    };
    dispatch(fetchArchiveProjects(params));
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      if (statusType === 'close') {
        handleSearchArchive();
      } else {
        handleSearchActive();
      }
    }
  };

  return (
    <div className="input-group mb-3">
      <input
        className="form-control"
        placeholder="Search project"
        type="text"
        aria-label="Search project"
        aria-describedby="Search project"
        onChange={(e) =>
          dispatch(
            statusType === 'active'
              ? setProjectSearchParam(e.target.value)
              : setArchiveProjectSearchParam(e.target.value)
          )
        }
        onKeyDown={handleKeyDown}
      />
      <Button
        variant="primary"
        onClick={() => {
          if (statusType === 'close') {
            handleSearchArchive();
          } else {
            handleSearchActive();
          }
        }}
      >
        <span className="mdi mdi-magnify" />
      </Button>
    </div>
  );
};

ProjectSearch.propTypes = {
  statusType: PropTypes.string,
};
export default ProjectSearch;
